import '@fontsource-variable/bricolage-grotesque';
import '@fontsource-variable/jetbrains-mono';
import './styles.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';

import { ApiError } from './api.js';
import { AuthProvider } from './auth.jsx';
import { mountAnnouncer } from './lib/announce.js';
import { registerServiceWorker } from './lib/pwa.js';
import { applyTheme, readTheme } from './lib/theme.js';
import { router } from './router.jsx';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Don't retry client errors (401/403/404/422): they won't fix themselves.
      retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 2,
      refetchOnWindowFocus: false,
    },
  },
});

// Before the first paint: the colours this browser chose (the account's choice follows with bootstrap).
applyTheme(readTheme());

// Before anything renders: a live region only reads out text written into it after it exists.
mountAnnouncer();

// The installable app's offline page (production builds only).
registerServiceWorker();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
